'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var load = 'load';
var loading = 'loading';
var loaded = 'loaded';
var error = 'error';
var noicon = 'noicon';
var offline = 'offline';

var icons = exports.icons = {
  load: load,
  loading: loading,
  loaded: loaded,
  error: error,
  noicon: noicon,
  offline: offline
};

var initial = 'initial';

var loadStates = exports.loadStates = {
  initial: initial,
  loading: loading,
  loaded: loaded,
  error: error
};


// WEBPACK FOOTER //
// ./node_modules/react-ideal-image/dist/components/constants.js